import { Injectable } from '@angular/core';

@Injectable()
export class CommunicationService {
  public data: any;

  constructor() {
    this.reset();
  }

  public reset(): void {
    this.data = null;
  }

  public getData<T>(): T {
    return <T>this.data;
  }

  public setData(data: any): void {
    this.data = data;
  }

  public isPresent(): boolean {
    return this.data != null;
  }
}
